<template>
  <div class="animated fadeIn">
    <b-form @submit.prevent="guardarTicket" name="ticketForm" data-vv-scope="formularioContacto">
      <b-row>
        <b-col lg="12" align-v="center">
          <b-card>

            <b-row>

              <b-col sm="6" >

                <b-row>
                  <b-col sm="12">
                    <b-form-group>
                      <label for="asunto">Asunto</label>
                      <b-form-input
                        type="text"
                        id="asunto"
                        name="asunto"
                        v-model="selectedTicket.asunto"
                        placeholder="Ingrese el asunto"
                        data-vv-as=" "
                        v-validate="'required'"
                      ></b-form-input>
                      <span class="text-danger span-error small">{{ errors.first('formularioContacto.asunto') }}</span>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row v-if="!admin">
                  <b-col sm="12">
                    <b-form-group>
                      <label for="empresa">Empresa</label>
                      <b-form-input
                        type="text"
                        id="empresa"
                        v-model="selectedTicket.empresa"
                        placeholder="Ingrese la empresa"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col sm="12">
                    <b-form-group>
                      <label for="nombre">Nombre</label>
                      <b-form-input
                        type="text"
                        id="nombre"
                        name="nombre"
                        v-model="selectedTicket.nombre"
                        placeholder="Ingrese su nombre"
                        data-vv-as=" "
                        v-validate="'required'"
                      ></b-form-input>
                      <span class="text-danger span-error small">{{ errors.first('formularioContacto.nombre') }}</span>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col sm="12">
                    <b-form-group>
                      <label for="email">Email</label>
                      <b-form-input
                        type="text"
                        id="email"
                        name="email"
                        v-model="selectedTicket.email"
                        placeholder="Ingrese su email"
                        data-vv-as=" "
                        v-validate="'required|email'"
                      ></b-form-input>
                      <span class="text-danger span-error small">{{ errors.first('formularioContacto.email') }}</span>
                    </b-form-group>
                  </b-col>
                </b-row>
                <br/>
                <b-form-file
                  id="adjunto"
                  placeholder="Selecciona un archivo fdf"
                  type="file"
                  name="adjunto"
                  browse-text="Buscar"
                  data-vv-as=" "
                  v-validate="'size:2048'"
                  accept="image/png, image/jpeg, image/jpg, application/pdf, application/vnd.ms-excel, application/msword, application/vnd.ms-powerpoint"
                >

                </b-form-file>
                <span class="text-danger span-error small">{{ errors.first('formularioContacto.adjunto') }}</span>
                <br/><br/>
              </b-col>

              <b-col sm="6">

                <b-row>
                  <b-col sm="12">
                    <label for="mensaje">Mensaje</label>
                    <b-form-textarea
                      id="mensaje"
                      v-model="selectedTicket.mensaje"
                      size="lg"
                      placeholder="Mensaje"
                      name="mensaje"
                      rows="8"
                      data-vv-as=" "
                      v-validate="'required'"
                    ></b-form-textarea>
                    <span class="text-danger span-error small">{{ errors.first('formularioContacto.mensaje') }}</span>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <br/><br/>
            <b-row>
                <b-col class="row justify-content-center">
                    <b-button :disabled="inactivo" variant="primary" class="align-center" type="submit">Guardar</b-button>
                </b-col>
            </b-row>
            <br/>
            <b-row>
                <b-col>
                    <b-button variant="secondary" class="align-center" @click="cambiaTicket" type="button"><i class="fa fa-reply fa-lg"></i>Volver</b-button>
                </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>

import { mapState, mapActions, mapMutations } from "vuex";

import tabla from "./Table";

export default {
  name: "tickets",
  props: ["admin"],
  components: {
    tabla
  },
  data() {
      return {
          inactivo: false,
      };
  },
  methods: {
    async guardarTicket() {
      this.$validator.validateAll("formularioContacto").then(async result => {
        if (result) {
          this.inactivo = true
          const file = document.getElementById('adjunto').files[0];
          const formData = new FormData();
          formData.append("adjunto", file);
          await this.guardaTicketContacto(formData);
          this.inactivo = false
        }
      })
    },
    async buscarEmpresa(query){
        if (query.length >= 3) {
            await this.getEmpresaFiltro(query)
        }
    },
    ...mapMutations('tickets', ["limpiarTicket"]),
    ...mapActions("tickets", ["guardaTicketContacto"]),
    ...mapActions('productos_et',[
        'getEmpresaFiltro'
    ]),
    ...mapMutations("autenticacion", ["cambiaTicket"])
  },
  computed: {
    ...mapState("tickets", [
        "defaultTicket",
        "selectedTicket",
        "status",
        "action"
      ]),
    ...mapState('productos_et',[
        'products',
        'filtroEt',
        'empresas',
        'selectedProduct',
        'id_empresa'
    ]),
    ...mapState("autenticacion", [
        "ticket"
    ])
  }

};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
